import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { modules } from "byzantine";
import {
  useFetchMappings,
  useCreateMapping,
  useUpdateMapping,
  useParseCSV,
  savedMappingToColumnMappings,
  columnMappingsToSavedMapping,
  getMissingRequiredFields,
} from "byzantine/src/dbbl/businessLogic/entities/wireImport";
import { useDomesticWireImportContext } from "./DomesticWireImportContext";
import { WIRE_FIELDS } from "./wireColumnMappingConstants";
import ColumnMappingScreen from "../CreateBulk/ColumnMappingScreen";

const extractSavedMappings = (
  data: unknown
): API.WireImport.CSVFieldMapping[] =>
  (data as { results: API.WireImport.CSVFieldMapping[] })?.results ?? [];

const WireColumnMappingScreen = () => {
  const navigate = useNavigate();
  const { csvResponse, setParsedRows } = useDomesticWireImportContext();
  const wireReasons = modules.wireTemplates.useWireReasons();

  const fields = useMemo(
    () =>
      wireReasons.length > 0
        ? WIRE_FIELDS
        : WIRE_FIELDS.filter((f) => f.field !== "wire_reason"),
    [wireReasons],
  );

  const onParseSuccess = useCallback(
    (result: API.WireImport.ParseCSV.Response) => {
      setParsedRows(result.rows);
      navigate("../review-recipients");
    },
    [setParsedRows, navigate]
  );

  return (
    <ColumnMappingScreen<
      API.WireImport.WireField,
      API.WireImport.ColumnMapping,
      API.WireImport.CSVFieldMapping,
      API.WireImport.ParseCSV.Response,
      API.WireImport.CSVFieldMappingRequest
    >
      titleKey="wire-column-mapping-title"
      backPath="../.."
      fields={fields}
      csvResponse={csvResponse}
      hooks={{
        useFetchMappings,
        useCreateMapping,
        useUpdateMapping,
        useParseCSV,
        savedMappingToColumnMappings,
        columnMappingsToSavedMapping,
        getMissingRequiredFields,
        extractSavedMappings,
      }}
      onParseSuccess={onParseSuccess}
    />
  );
};

export default WireColumnMappingScreen;
